// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IncrementBtnCircle-incrementDecrementButton-F1JLL {
	width: 120px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	overflow: hidden;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.IncrementBtnCircle-tableCell-fUG_s {
	display: table-cell;
	vertical-align: middle;
}

.IncrementBtnCircle-incrementDecrementText-YOPqh {
	word-wrap: break-word;
	font-size: 16px;
	line-height: 22px;
	letter-spacing: normal;
	font-weight: normal;
	margin: 0px !important;
}

.IncrementBtnCircle-iconButton-aB_hd,
.IncrementBtnCircle-iconButton-aB_hd:hover,
.IncrementBtnCircle-iconButton-aB_hd:focus,
.IncrementBtnCircle-iconButton-aB_hd:active,
.IncrementBtnCircle-iconButton-aB_hd:active:hover {
	display: inline-block;
	cursor: pointer;
	text-align: center;
	line-height: 1;
	position: relative;
	-ms-touch-action: manipulation;
	    touch-action: manipulation;
	width: 32px;
	height: 32px;
	-webkit-box-shadow: none;
	        box-shadow: none;
	border-radius: 50%;
	border: 1px solid var(--secondary-bg) !important;
	background: var(--secondary-bg) !important;
	padding: 1px 6px;
	color: var(--common-primary-white-foreground);
	outline: 0 !important;
	box-shadow: none;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.IncrementBtnCircle-iconButton-aB_hd:disabled,
.IncrementBtnCircle-iconButton-aB_hd:disabled:hover,
.IncrementBtnCircle-iconButton-aB_hd:disabled:focus,
.IncrementBtnCircle-iconButton-aB_hd:disabled:active,
.IncrementBtnCircle-iconButton-aB_hd:disabled:active:hover {
	border: 1px solid var(--secondary-bg) !important;
	background: var(--secondary-bg) !important;
	padding: 1px 6px;
	color: var(--common-primary-white-foreground);
	cursor: default;
	opacity: 0.65;
	filter: alpha(opacity=65);
	-webkit-box-shadow: none;
	        box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/components/IncrementBtnCircle/IncrementBtnCircle.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,gBAAgB;CAChB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,sBAAsB;CACtB,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;;;;;CAKC,qBAAqB;CACrB,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,8BAA0B;KAA1B,0BAA0B;CAC1B,WAAW;CACX,YAAY;CACZ,wBAAgB;SAAhB,gBAAgB;CAChB,kBAAkB;CAClB,gDAAgD;CAChD,0CAA0C;CAC1C,gBAAgB;CAChB,6CAA6C;CAC7C,qBAAqB;CACrB,gBAAgB;CAChB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;;;;;CAKC,gDAAgD;CAChD,0CAA0C;CAC1C,gBAAgB;CAChB,6CAA6C;CAC7C,eAAe;CACf,aAAa;CACb,yBAAyB;CACzB,wBAAgB;SAAhB,gBAAgB;AACjB","sourcesContent":[".incrementDecrementButton {\n\twidth: 120px;\n\tdisplay: flex;\n\toverflow: hidden;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.incrementDecrementText {\n\tword-wrap: break-word;\n\tfont-size: 16px;\n\tline-height: 22px;\n\tletter-spacing: normal;\n\tfont-weight: normal;\n\tmargin: 0px !important;\n}\n\n.iconButton,\n.iconButton:hover,\n.iconButton:focus,\n.iconButton:active,\n.iconButton:active:hover {\n\tdisplay: inline-block;\n\tcursor: pointer;\n\ttext-align: center;\n\tline-height: 1;\n\tposition: relative;\n\ttouch-action: manipulation;\n\twidth: 32px;\n\theight: 32px;\n\tbox-shadow: none;\n\tborder-radius: 50%;\n\tborder: 1px solid var(--secondary-bg) !important;\n\tbackground: var(--secondary-bg) !important;\n\tpadding: 1px 6px;\n\tcolor: var(--common-primary-white-foreground);\n\toutline: 0 !important;\n\tbox-shadow: none;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.iconButton:disabled,\n.iconButton:disabled:hover,\n.iconButton:disabled:focus,\n.iconButton:disabled:active,\n.iconButton:disabled:active:hover {\n\tborder: 1px solid var(--secondary-bg) !important;\n\tbackground: var(--secondary-bg) !important;\n\tpadding: 1px 6px;\n\tcolor: var(--common-primary-white-foreground);\n\tcursor: default;\n\topacity: 0.65;\n\tfilter: alpha(opacity=65);\n\tbox-shadow: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"incrementDecrementButton": `IncrementBtnCircle-incrementDecrementButton-F1JLL`,
	"tableCell": `IncrementBtnCircle-tableCell-fUG_s`,
	"incrementDecrementText": `IncrementBtnCircle-incrementDecrementText-YOPqh`,
	"iconButton": `IncrementBtnCircle-iconButton-aB_hd`
};
module.exports = ___CSS_LOADER_EXPORT___;
